<template>
  <div :class="`image-${wrapperStyle}-width-${size}`">
    <img :src="imageUrl" v-if="urlIsValid || forceImageShow" />
    <p v-else>{{ nameInitials }}</p>
  </div>
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: String,
      default: ""
    },
    size: {
      type: Number,
      default: 50
    },
    name: {
      type: String,
      default: ""
    },
    wrapperStyle: {
      type: String,
      default: "square"
    },
    forceImageShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    nameInitials() {
      return this.name
        .split(" ")
        .map(item => item.charAt())
        .join("");
    },
    urlIsValid() {
      if (!this.imageUrl) return false;
      try {
        new URL(this.imageUrl);
        return true;
      } catch {
        return false;
      }
    }
  }
};
</script>

<style lang="sass">
@import "../scss/_variable"

@for $size from 20 through $maximum-height-width
  .image-square-width-#{$size}
    height: #{$size}px
    width: #{$size}px
    border-radius: 5px
    background-color: $primary-color
    text-transform: uppercase
    color: white
    overflow: hidden
    @media only screen and (max-width: 90em)
      height: #{$size + 1}px
      width: #{$size + 1}px
    p
      text-align: center
      font-size: #{$size/2}px
      line-height: #{$size}px
    img
      height: 100%
      width: 100% !important
      object-fit: cover

@for $size from 20 through $maximum-height-width
  .image-circle-width-#{$size}
    height: #{$size}px
    width: #{$size}px
    border-radius: 50%
    background-color: $primary-color
    text-transform: uppercase
    color: white
    overflow: hidden
    @media only screen and (max-width: 90em)
      height: #{$size + 1}px
      width: #{$size + 1}px
    p
      text-align: center
      font-size: #{$size/2}px
      line-height: #{$size}px
    img
      height: 100%
      width: 100% !important
      object-fit: cover
</style>
